class QuantitySelector extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.input = this.querySelector('input[type="number"]');
    this.minus = this.querySelector('button[name="minus"]');
    this.plus = this.querySelector('button[name="plus"]');
    if (!this.input || !this.minus || !this.plus) return;
    this.previous = Number(this.input.value) || 1;
    const options = {signal:this.controller.signal};
    this.minus.addEventListener('click', e => {e.preventDefault();this.adjust(-1);}, options);
    this.plus.addEventListener('click', e => {e.preventDefault();this.adjust(1);}, options);
    this.input.addEventListener('change', () => this.validate(), options);
    this.updateButtons();
  }
  disconnectedCallback() {this.controller?.abort();}
  limits() {
    const minimum = Number(this.input.getAttribute('min'));
    const maximum = Number(this.input.getAttribute('max'));
    return {min:Math.max(0, Number.isFinite(minimum) ? minimum : 1),max:maximum > 0 ? maximum : Infinity};
  }
  adjust(delta) {
    const {min,max} = this.limits();
    const value = Math.min(max,Math.max(min,(Number(this.input.value)||this.previous)+delta));
    if (value === Number(this.input.value)) return;
    this.input.value = String(value);
    this.previous = value;
    this.updateButtons();
    this.input.dispatchEvent(new Event('change',{bubbles:true}));
  }
  validate() {
    const {min,max} = this.limits();
    const value = Number(this.input.value);
    this.input.value = String(Number.isInteger(value) && value >= min && value <= max ? value : this.previous);
    this.previous = Number(this.input.value);
    this.updateButtons();
  }
  setQuantity(value) {this.input.value=String(value);this.validate();this.input.dispatchEvent(new Event('change',{bubbles:true}));}
  updateButtons() {const {min,max}=this.limits();this.minus.disabled=Number(this.input.value)<=min;this.plus.disabled=Number(this.input.value)>=max;}
}
if (!customElements.get('quantity-selector')) customElements.define('quantity-selector',QuantitySelector);
